// extracted by mini-css-extract-plugin
export var closeButton = "_q9-2";
export var closeButtonIcon = "_q9-3";
export var lightboxContent = "_q9-1";
export var lightboxOverlay = "_q9-0";